import { ReactNode } from 'react';

import { isNotDefined } from 'utils/ramda';

import TourTooltip from './TourTooltip';
import { desktopTooltips, mobileTooltips } from './TourTooltip/constants';
import { INotification } from './TourTooltip/types';

export const withNotificationCenter = (
  element: ReactNode,
  notifications: INotification[],
  isMobile: boolean = false,
) => {
  if (isNotDefined(notifications)) return null;

  const { hasGP } = notifications[0];
  const formattedMobileTooltips = hasGP ? mobileTooltips : mobileTooltips.slice(1);
  const tooltips = isMobile ? formattedMobileTooltips : desktopTooltips;

  return (
    <TourTooltip steps={tooltips.length} cards={tooltips} notifications={notifications}>
      {element}
    </TourTooltip>
  );
};
